import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './Translation/LanguageSwitcher';

export default function Navbar() {
  const [shownavoptions, setShowNavOptions] = useState(false);
  const [opensection, setOpensection] = useState(false);
  // const [lang,setLang]=useState('العربية')
  const [rippleStyle, setRippleStyle] = useState({});
  const [isAnimating, setIsAnimating] = useState(false);
  const  { t }=useTranslation()

  const handleMouseEnter = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    setRippleStyle({
      top: y,
      left: x,
    });
    setIsAnimating(true);
  };

  const handleClick = (e) => {
    handleMouseEnter(e);
  };

  const handleMouseLeave = () => {
    setIsAnimating(false);
  };
  
  return (
    <div className="bg-main-background-color flex w-full items-center justify-center py-3 px-4">
      <div className={`bg-white flex w-full max-w-7xl justify-between items-center p-3 rounded-lg relative ${shownavoptions ? 'rounded-bl-none rounded-br-none' : 'rounded-bl-lg rounded-br-lg'}`}>
        <Link to="/">
          <img className="w-12" src="assets/logo.png" alt="Logo" />
        </Link>

        {/* Navbar Menu for large screen */}
        <div className="hidden lg:flex space-x-6 text-sm text-gray-700 font-medium relative">
          <LanguageSwitcher
          className="px-6"          
          />
          <motion.div
            className="flex flex-col items-center justify-center cursor-pointer group hover:text-black transition relative"
            onMouseEnter={() => setOpensection(true)}
            onMouseLeave={() => setOpensection(false)}
          >
            <div className="flex gap-2 items-center group">
              <span>{t("navbar.investments")}</span>
              <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg" className="transform transition-transform duration-300 group-hover:rotate-180">
                <path d="M1 1.09131L7 7.09131L13 1.09131" stroke="#272727" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            
            {/* Dropdown Content for Large Screen */}
            <AnimatePresence>
              {opensection && (
                <motion.div
                  className="absolute top-full w-48 bg-white border border-gray-300 shadow-lg rounded-md z-30"
                  initial={{ opacity: 0, y: -20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  transition={{ duration: 0.3, ease: 'easeOut' }}
                >
                  <ul className="flex flex-col space-y-3 p-3 text-gray-600 text-sm">
                    <Link to="/financial"><li className='hover:text-black cursor-pointer'>{t("navbar.dropdownOptions.financial")}</li></Link>
                    <Link to="/energyandmaterial"><li className='hover:text-black cursor-pointer'>{t("navbar.dropdownOptions.energyAndMaterial")}</li></Link>
                    <Link to="/transport"><li className='hover:text-black cursor-pointer'>{t("navbar.dropdownOptions.transport")}</li></Link>
                    <Link to="/food"><li className='hover:text-black cursor-pointer'>{t("navbar.dropdownOptions.food")}</li></Link>
                    <Link to="/manufacturing"><li className='hover:text-black cursor-pointer'>{t("navbar.dropdownOptions.manufacturing")}</li></Link>
                    <Link to="/realestate"><li className='hover:text-black cursor-pointer'>{t("navbar.dropdownOptions.realEstate")}</li></Link>
                    <Link to="/education"><li className='hover:text-black cursor-pointer'>{t("navbar.dropdownOptions.education")}</li></Link>
                    <li className="hover:text-black cursor-pointer">{t("navbar.dropdownOptions.others")}</li>
                  </ul>
                </motion.div>
              )}
            </AnimatePresence>
          </motion.div>

          {/* ABOUT US Link */}
          <Link to="/about" className='flex items-center cursor-pointer hover:text-black transition'>
            <div>
              <p>{t("navbar.aboutUs")}</p>
            </div>
          </Link>

          {/* CONTACT Button with animation */}
          <Link to="/contact">
            <div className="cursor-pointer">
              <motion.button
                className="relative bg-white text-black border px-6 py-3 rounded-lg overflow-hidden cursor-pointer transition-transform duration-300"
                onMouseEnter={handleMouseEnter}
                onClick={handleClick}
                onMouseLeave={handleMouseLeave}
              >
                {/* Ripple effect */}
                <AnimatePresence>
                  {isAnimating && (
                    <motion.span
                      className="absolute w-4 h-4 rounded-full"
                      style={{
                        top: rippleStyle.top,
                        left: rippleStyle.left,
                        backgroundColor: 'grey',
                      }}
                      initial={{ scale: 0, opacity: 1 }}
                      animate={{ scale: 20, opacity: 0.5 }}
                      exit={{ opacity: 0 }}
                      transition={{ duration: 0.8, ease: 'easeOut' }}
                    />
                  )}
                </AnimatePresence>
                {t("navbar.contact")}
              </motion.button>
            </div>
          </Link>
        </div>

        {/* Mobile Menu Hamburger Icon */}
        <div className="lg:hidden flex items-center cursor-pointer" onClick={() => { setShowNavOptions(!shownavoptions); }}>
          <svg width="24" height="16" viewBox="0 0 24 16" fill="none" className={shownavoptions? 'hidden':'block'} xmlns="http://www.w3.org/2000/svg">
            <path d="M0.5 0.903809H23.5M8.5 8.09131L23.5 8.09131M4.5 15.2788L23.5 15.2788" stroke="black" />
          </svg>
          <svg width="20" height="21" viewBox="0 0 20 21" fill="none" className={shownavoptions? 'block':'hidden'} xmlns="http://www.w3.org/2000/svg">
            <path d="M19.5834 0.507812L0.416748 19.6745M19.5834 19.6745L0.416748 0.507812" stroke="black"/>
          </svg>
        </div>

        {/* Mobile Dropdown */}
        <AnimatePresence>
          {shownavoptions && (
            <motion.div
              className="lg:hidden flex flex-col space-y-3 min-h-[70vh] p-4 bg-white absolute left-0 right-0 top-full w-full z-20"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ duration: 0.3, ease: 'easeOut' }}
            >
              <div className="cursor-pointer hover:text-main-hover-color transition">
                <div>
                  <div className="flex w-full items-center justify-between py-2" onClick={() => setOpensection(!opensection)}>
                    <span>{t("navbar.investments")}</span>
                    <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg" className={`ml-2 tranform ${opensection ? "rotate-180":"rotate-0"}`}>
                      <path d="M1 1.09131L7 7.09131L13 1.09131" stroke="#272727" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                  {opensection && (
                    <div>
                      <ul className="flex flex-col space-y-3 ml-2">
                        <Link to="/financial" onClick={() => setShowNavOptions(false)}><li>{t("navbar.dropdownOptions.financial")}</li></Link>
                        <Link to="/energyandmaterial" onClick={() => setShowNavOptions(false)}><li>{t("navbar.dropdownOptions.energyAndMaterial")}</li></Link>
                        <Link to="/transport" onClick={() => setShowNavOptions(false)}><li>{t("navbar.dropdownOptions.transport")}</li></Link>
                        <Link to="/food" onClick={() => setShowNavOptions(false)}><li>{t("navbar.dropdownOptions.food")}</li></Link>
                        <Link to="/manufacturing" onClick={() => setShowNavOptions(false)}><li>{t("navbar.dropdownOptions.food")}</li></Link>
                        <Link to="/realestate" onClick={() => setShowNavOptions(false)}><li>{t("navbar.dropdownOptions.realEstate")}</li></Link>
                        <Link to="/education" onClick={() => setShowNavOptions(false)}><li>{t("navbar.dropdownOptions.education")}</li></Link>
                        <li onClick={() => setShowNavOptions(false)}>{t("navbar.dropdownOptions.others")}</li>
                      </ul>
                    </div>
                  )}
                </div>
              </div>

              {/* About Us Link */}
              <Link to="/about" className="cursor-pointer hover:text-main-hover-color transition py-2" onClick={() => setShowNavOptions(false)}>
                <p>{t("navbar.aboutUs")}</p>
              </Link>

              {/* Careers Link */}
              <div className="cursor-pointer hover:text-main-hover-color transition py-2">
                <p>{t("navbar.contact")}</p>
              </div>

              <div className="cursor-pointer hover:text-main-hover-color transition py-2">
                <LanguageSwitcher
                  className="px-6"          
                />
              </div>

              {/* Contact Button */}
              <Link to="/contact" onClick={() => setShowNavOptions(false)}>
                <div className="cursor-pointer w-full flex justify-center items-center">
                  <button className="bg-main-button-bg w-full text-black border px-3 py-2 rounded-lg hover:bg-main-button-hover transition">
                    CONTACT
                  </button>
                </div>
              </Link>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
}
